import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getOperatorBreaks = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/breaks?${queries}` });

  return data;
};

export default getOperatorBreaks;
